"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Radio_styles_1 = require("./Radio.styles");
var enums_1 = require("../../../enums");
var Radio = function (_a) {
    var value = _a.value, classes = _a.classes, onChangeRadio = _a.onChangeRadio, disabled = _a.disabled, _b = _a.color, color = _b === void 0 ? enums_1.Color.primary : _b, label = _a.label;
    var defaultClasses = (0, Radio_styles_1.useRadioStyles)();
    var styles = classes ? tslib_1.__assign(tslib_1.__assign({}, defaultClasses), classes) : defaultClasses;
    return (react_1.default.createElement(core_1.FormControlLabel, { classes: {
            root: styles.controlLabel,
            disabled: styles.disabled,
            label: styles.label,
        }, value: value, disabled: disabled, control: react_1.default.createElement(core_1.Radio, { color: color, disabled: disabled, classes: {
                root: styles.root,
                checked: styles.checked,
                colorPrimary: styles.colorPrimary,
                disabled: styles.disabled,
            }, onChange: onChangeRadio }), label: label }));
};
exports.Radio = Radio;
